import React from 'react';
import AsperFooterLogo from 'assets/svg/AsperFooterLogo';
import JiraComponent from 'components/organism/JiraComponent';
import ProductFruitHelpLauncher from 'components/molecules/ProductFruitHelpLauncher';
import { POWERED_BY_FOOTER_HEIGHT_PX } from 'config/constants';

const PoweredByFooter: React.FC = () => {
    const showJiraBugReport = process.env.REACT_APP_JIRA_ENABLE_BUG_REPORT === 'true';
    const workspace = process.env.REACT_APP_VITE_PRODUCT_FRUIT_WORKSPACE;
    const showHelpLauncher = Boolean(workspace && workspace !== 'null');
    const showFooterActions = showJiraBugReport || showHelpLauncher;

    return (
        <div
            className="powered-by-footer fixed bottom-0 left-0 right-0 z-[150] flex w-full items-center justify-between overflow-visible"
            style={{ height: POWERED_BY_FOOTER_HEIGHT_PX }}
        >
            <div className="flex h-full items-center gap-2 pl-4">
                <span className="powered-by-footer__label">Powered by</span>
                <AsperFooterLogo className="powered-by-footer__logo" />
            </div>
            {showFooterActions && (
                <div className="flex h-full items-center gap-2 shrink-0">
                    {showJiraBugReport && <JiraComponent size={24} />}
                    <ProductFruitHelpLauncher />
                </div>
            )}
        </div>
    );
};

export default PoweredByFooter;
